export default __webpack_public_path__ + "static/media/113t.fce30ffe.jpg";